
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M.75 23.25v-1.5a1.5 1.5 0 013 0v1.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M21.75 20.25v-4.5a1.5 1.5 0 00-1.5-1.5H3.75a1.5 1.5 0 00-1.5 1.5v4.5"}}),_c('path',{staticClass:"a",attrs:{"d":"M23.25 23.25v-1.5a1.5 1.5 0 00-3 0v1.5M18 19.026a3.006 3.006 0 001.5-2.6V11.25a7.5 7.5 0 00-15 0v5.176a3 3 0 001.5 2.6 12.01 12.01 0 0012 0zM9 9v1.5M15 9v1.5M12 3.75v-3"}})])
          )
        }
      }
    